class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.notification.addEventListener('click', this.onNotificationClick.bind(this));
  }

  onNotificationClick(event) {
    const addButton = event.target.closest('[data-tester-upsell-add]');
    if (!addButton) return;
    event.preventDefault();
    event.stopPropagation();
    this.addTesterUpsell(addButton);
  }

  addTesterUpsell(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    const variantId = button.getAttribute('data-tester-variant-id');
    if (!variantId) return;

    const upsell = button.closest('[data-tester-upsell]');
    const status = upsell?.querySelector('[data-tester-upsell-status]');

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    if (status) {
      status.hidden = true;
      status.textContent = '';
      status.classList.remove('is-success', 'is-error');
    }

    const sections = this.getSectionsToRender().map((section) => section.id);
    const body = JSON.stringify({
      id: Number(variantId),
      quantity: 1,
      sections,
      sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_add_url + '.js', {
      ...fetchConfig('javascript'),
      body,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (status) {
            status.hidden = false;
            status.classList.add('is-error');
            status.textContent = response.description || response.message || 'Could not add tester.';
          }
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
          return;
        }

        // Refresh cart count / view cart button from returned sections.
        this.getSectionsToRender().forEach((section) => {
          if (section.id === 'cart-notification-product') return;
          const el = document.getElementById(section.id);
          if (!el || !response.sections || !response.sections[section.id]) return;
          el.innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector);
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'tester-upsell',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (upsell) {
          upsell.innerHTML =
            '<p class="cart-notification-tester-upsell__text cart-notification-tester-upsell__status is-success">Tester added to your cart.</p>';
        }
      })
      .catch((error) => {
        console.error(error);
        if (status) {
          status.hidden = false;
          status.classList.add('is-error');
          status.textContent = 'Could not add tester.';
        }
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
